import { render, staticRenderFns } from "./ServiceCrud.vue?vue&type=template&id=41361d11"
import script from "./ServiceCrud.vue?vue&type=script&lang=js"
export * from "./ServiceCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports